import { ICONE } from 'icons'
import { BaseHeaderConIcona } from 'layout'

export default function HeaderContenutoMultimediale(props) {
  const { contenuto, ...restProps } = props
  const { titolo, note } = contenuto

  return (
    <BaseHeaderConIcona
      titolo={titolo || '(titolo non inserito)'}
      sottotitolo={note}
      icona={<ICONE.VIDEO />}
      {...restProps}
    />
  )
}